import React, { useState } from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-43">
      <button onClick={onToggle} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-44">
        <h3 className={`text-lg font-bold font-heading pr-8 transition-colors ${isOpen ? 'text-accent' : 'text-nav group-hover:text-accent'}`} data-id="element-45">
          {question}
        </h3>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-accent text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-gray-200'}`} data-id="element-46">
          {isOpen ? <ChevronUp size={20} data-id="element-47" /> : <ChevronDown size={20} data-id="element-48" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-49">
        <p className="text-gray-600 leading-relaxed" data-id="element-50">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'WHAT ARE SOME OF THE BENEFITS OF TAE KWON DO TRAINING?',
    answer: 'Health Benefits. As well as the sporting and self-defence aspects to Taekwondo, the exercise one gets from martial arts training improves balance, flexibility, stamina, strength and posture. … Increased strength and stamina. Improved confidence.'
  }, {
    question: 'HOW IS TAEKWONDO DIFFERENT FROM OTHER MARTIAL ARTS?',
    answer: 'The different martial arts all originated in different countries thousands of years ago, as forms of self-defense. Karate comes from Japan and Kung Fu from China. Taekwondo is native to Korea. In terms of techniques, Taekwondo is known as the kicking art and emphasizes kicks more than other martial arts.'
  }, {
    question: 'HOW LONG SHOULD IT TAKE TO GET A BLACK BELT IN TAEKWONDO?',
    answer: 'In Taekwondo, it is likely that a dedicated student will be eligible to test for a 1st Degree Black Belt (Il Dan) after 3 to 5 years (at my Dojang, the minimum time is 4 years). Students can fail a Taekwondo test, and I have seen it happen many times over my decades in this art.'
  }, {
    question: 'DO I NEED TO BE FIT TO DO TAEKWONDO?',
    answer: 'Not necessarily, in fact a lot of people actually join Taekwondo to get fit! In parts, fitness does help but the Instructor know that everyone is different and always try to ensure students push themselves where they can in attempt to attain higher and better personal levels and goals.'
  }];
  return <section className="py-20 bg-white" data-id="element-51">
      <Container className="max-w-4xl" data-id="element-52">
        <div className="text-center mb-12" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-extrabold text-nav mb-4 uppercase tracking-tight font-heading" data-id="element-54">
            Common Questions Before You Start
          </h2>
          <div className="w-20 h-1 bg-accent mx-auto mb-6" data-id="element-55"></div>
        </div>

        <div className="bg-white rounded-lg mb-12" data-id="element-56">
          {faqs.map((faq, index) => <FAQItem key={index} {...faq} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-57" />)}
        </div>

        <div className="text-center" data-id="element-58">
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-59">
            <a href="#signup" data-id="element-60">
              <Button variant="primary" size="lg" data-id="element-61">
                Get One Week Free Trial
              </Button>
            </a>
            <a href="tel:8472128045" data-id="element-62">
              <Button variant="default" size="lg" data-id="element-63">
                Call (847) 212-8045
              </Button>
            </a>
          </div>
        </div>
      </Container>
    </section>;
}